"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brainswap = void 0;
exports.brainswap = {
    masterchef: '0x616CAFA10C2EE31B2da90d9511C92d84bA3F4Fc7',
};
